import { render, staticRenderFns } from "./cate04.vue?vue&type=template&id=9e838002"
import script from "./cate04.vue?vue&type=script&lang=js"
export * from "./cate04.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports